<template>
  <span>
    <slot :total1v1="total1v1" :total2v2="total2v2">
      There are currently
      <strong v-if="fanDeckCount">{{ fanDeckCount.toLocaleString() }}</strong>
      <b-spinner v-else small label="Loading"></b-spinner>
      published fan decks. Including the
      <strong v-if="officialDeckCount">{{
        officialDeckCount.toLocaleString()
      }}</strong>
      <b-spinner v-else small label="Loading"></b-spinner>
      official decks, that makes
      <strong v-if="total1v1">{{ total1v1.toLocaleString() }}</strong>
      <b-spinner v-else small label="Loading"></b-spinner>
      possible 1-on-1 match-ups and
      <strong v-if="total2v2">{{ total2v2.toLocaleString() }}</strong>
      <b-spinner v-else small label="Loading"></b-spinner>
      possible 2-on-2 match-ups.
    </slot>
  </span>
</template>

<script type="text/javascript">
export default {
  name: "MatchupCount",
  props: {
    fanDeckCount: Number,
    officialDeckCount: Number
  },
  computed: {
    total1v1() {
      const totalDecks = this.fanDeckCount + this.officialDeckCount;
      if (totalDecks === 0) return 0;
      return (totalDecks * (totalDecks - 1)) / 2;
    },
    total2v2() {
      const totalDecks = this.fanDeckCount + this.officialDeckCount;
      if (totalDecks === 0) return 0;

      return (
        (totalDecks * (totalDecks - 1) * (totalDecks - 2) * (totalDecks - 3)) /
        8
      );
    }
  }
};
</script>
